// Dịch các lable của phân trang
export const translatePaginator = ['Số dòng', 'Trang đầu', 'Trang trước', 'Trang tiếp theo', 'Trang cuối', 'của'];

// Date picker format
export const PICK_FORMATS = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
};

export const reloadTimeout = 1500; // milisecond
export const pageSizeOptions = [10, 20, 50, 100, 200, 500];
export const cmuPageSizeOptions = [20, 50, 100, 200, 500];
export const pageSizeOptionsHuy = [5, 10, 20, 50, 100, 200, 500];
export const pageSizes = [5, 10, 20, 50];
export const pageSizesHoSo = [5, 10, 20, 50];
export const pages = [100, 200, 500, 1000, 1500];
export const gioiTinhList: any[] = [
  { id: 1, name: 'BAO_TRO_XA_HOI.INPUT.MALE' },
  { id: 0, name: 'BAO_TRO_XA_HOI.INPUT.FEMALE' },
];

export const months: any[] = [
  { value: "01", name: "Tháng 1" },
  { value: "02", name: "Tháng 2" },
  { value: "03", name: "Tháng 3" },
  { value: "04", name: "Tháng 4" },
  { value: "05", name: "Tháng 5" },
  { value: "06", name: "Tháng 6" },
  { value: "07", name: "Tháng 7" },
  { value: "08", name: "Tháng 8" },
  { value: "09", name: "Tháng 9" },
  { value: "10", name: "Tháng 10" },
  { value: "11", name: "Tháng 11" },
  { value: "12", name: "Tháng 12" },
];

export const THANG_TONG_HOP = [
  { name: "Cả năm", value: "null" },
  { name: "6 tháng đầu năm", value: ['01', '02', '03', '04', '05', '06'] },
  { name: "6 tháng cuối năm", value: ['07', '08', '09', '10', '11', '12'] },
  { name: "Quý 1", value: ['01', '02', '03'] },
  { name: "Quý 2", value: ['04', '05', '06'] },
  { name: "Quý 3", value: ['07', '08', '09'] },
  { name: "Quý 4", value: ['10', '11', '12'] },
];
export const THANG_TONG_HOP_VLG = [
  { name: "Cả năm", value: "null" },
  // { name: "6 tháng đầu năm", value: ['01', '02', '03', '04', '05', '06'] },
  // { name: "6 tháng cuối năm", value: ['07', '08', '09', '10', '11', '12'] },
  // { name: "Quý 1", value: ['01', '02', '03'] },
  // { name: "Quý 2", value: ['04', '05', '06'] },
  // { name: "Quý 3", value: ['07', '08', '09'] },
  // { name: "Quý 4", value: ['10', '11', '12'] },
];
export const QUY = [
  { ten: 'Quý 1', id: '0', tuNgay: '-01-01', denNgay: '-03-31'},
  { ten: 'Quý 2', id: '1', tuNgay: '-04-01', denNgay: '-06-31'},
  { ten: 'Quý 3', id: '2', tuNgay: '-07-01', denNgay: '-09-31'},
  { ten: 'Quý 4', id: '3', tuNgay: '-10-01', denNgay: '-12-31'},
  { ten: 'Năm', id: '4', tuNgay: '-01-01', denNgay: '-12-31'},
]

export const DANH_MUC_CHUC_DANH = {
  CV_GIAM_NGHEO_HUYEN: 13,
  CV_GIAM_NGHEO_XA:    16,
  TTDVVL:              36,
  TT_BTXH:             40,
  CV_HUYEN_QTH:        46,
  CV_GN_XA_QTH:        47,
  CV_BTXH_XA_QTH:      48,
  CAN_BO_XA_LDVL:      37,
  CAN_BO_HUYEN_LDVL:   49,
  LANH_DAO_TINH_LDVL:  11,
  TT_BTXH_VLG:         67,
  TT_BTXH_QLDT_VLG:    88,
  TT_BTXH_QLKPNHT_VLG: 89,
};

export const years: any[] = [
  { value: "2019", name: "Năm 2019" },
  { value: "2020", name: "Năm 2020" },
  { value: "2021", name: "Năm 2021" },
  { value: "2022", name: "Năm 2022" },
  { value: "2023", name: "Năm 2023" },
  { value: "2024", name: "Năm 2024" },
  { value: "2025", name: "Năm 2025" },
  { value: "2026", name: "Năm 2026" },
  { value: "2027", name: "Năm 2027" },
  { value: "2028", name: "Năm 2028" },
  { value: "2029", name: "Năm 2029" },
  { value: "2030", name: "Năm 2030" },
];

export const trangThaiChiTra: any[] = [
  { value: false, name: 'Chưa trả' },
  { value: true, name: 'Đã trả' }
];

export const TrangThai = [
  { value: true , name: 'Đang hoạt động' },
  { value: false, name: 'Đã khóa' }
];

export const TRANG_THAI_QUY_TRINH = {
  CHUA_LAP_DANH_SACH:                   0,
  LAP_MOI_DANH_SACH:                    1,
  CHUYEN_PHE_DUYET_DANH_SACH_LAP:       2,
  DA_PHE_DUYET_DANH_SACH_LAP:           3,
  TU_CHOI_PHE_DUYET_DANH_SACH_LAP:      4,
  TONG_HOP_DU_LIEU:                     5,
  CHUYEN_PHE_DUYET_DANH_SACH_TONG_HOP:  6,
  CHOT_DU_LIEU_TONG_HOP:                7,
  HUY_DANH_SACH_TONG_HOP:               8,
  DONG_KY_CHI_TRA:                      9,
  TU_CHOI_PHE_DUYET_DANH_SACH_TONG_HOP: 10
};

export const TRANG_THAI_HO_SO = {
  BI_TU_CHOI:     -1,
  CHUA_PHE_DUYET: 0,
  DA_PHE_DUYET:   1,
  DANG_XU_LY:     2,
  DA_HOAN_TAT:    3,
  DA_CHI_TRA:     4,
};

export const LOAI_CANH_BAO = {
  LAP_DANH_SACH:      1,
  TU_CHOI_PHE_DUYET:  2,
  DA_PHE_DUYET:       3
};

export const LOAI_BAO_CAO_CHI_TRA = {
  DANH_SACH_CHI_TRA_DA_LAP: 1,
  DANH_SACH_CHI_TRA:        2, // Gồm 3 + 4
  DANH_SACH_NGUOI_CAO_TUOI: 3,
  DANH_SACH_TAN_TAT:        4
};

export const LOAI_BAO_CAO_CHI_TRA_LIST = [
  {
    value: 1,
    name: "Xuất excel danh sách chi trả trợ cấp hàng tháng",
    classCss: 'fa fa-file-excel-o icon-excel'
  },
  {
    value: 2,
    name: "Xuất danh sách chi trả trợ cấp",
    classCss: 'fa fa-file-pdf-o icon-pdf'
  },
  {
    value: 3,
    name: "Xuất danh sách người cao tuổi hưởng trợ cấp hàng tháng",
    classCss: 'fa fa-file-pdf-o icon-pdf'
  },
  {
    value: 4,
    name: "Xuất danh sách người khuyết tật hưởng trợ cấp hàng tháng",
    classCss: 'fa fa-file-pdf-o icon-pdf'
  }
];

export const TRANG_THAI_LOAI_THOI_HUONG = {
  TANG_MOI:             1,
  DANG_HUONG:           2,
  HUONG_LAI:            3,
  TAM_DUNG_TRO_CAP:     4,
  DINH_CHI_TRO_CAP:     5,
  DIEU_CHINH_GIAM_DO:   6,
  DIEU_CHINH_TANG_DO:   7,
  DIEU_CHINH_TANG:      8,
  DIEU_CHINH_GIAM:      9,
  CAT_CHET:             10,
  DIEU_CHINH_KHONG_DOI: 11
}

export const MA_HOAN_CANH_BAO_CAO = {
  HO_NGHEO:  1,
  CAN_NGHEO: 2
}

export const LOAI_CHINH_SACH_DEFAULT = "NĐ 136";
export const ID_ND136_NUM = 1;
export const ID_ND136_STR = '1';
export const ID_COVID_NQ68 = 71;
export const ID_CS_DIA_PHUONG = 82;
export const ID_QD28 = 3;
export const ID_QD28_STR = '3';
export const ID_ND20_NUM = 79;
export const ID_ND20_STR = '79';
export const MA_ADMIN = 9;
export const ID_CHUC_THO = 83;
export const ID_LOAI_DT_DIEU_TRI_COVID = 60;
export const ID_CHUC_THO_STR = '83';

// Trẻ em
export const TE_HCDB = {
  VALUE: 282,
  TEXT: "Trẻ em có hoàn cảnh đặc biệt (HCĐB)"
}

export const ID_CHU_HO = "00";
export const CHUC_DANH_CVBT_XA = 17;
export const CHUC_DANH_CVBT_XA_CHI_TRA = 26;
export const CHUC_DANH_CVGN_XA = 16;
export const TAB_QUY_TRINH_CHUYEN_VUNG = [
  {
    ID: 0,
    KY_HIEU: 'ho-chuyen-di',
    NAME: 'Danh sách yêu cầu chuyển vùng hộ gia đình sang địa phương khác'
  },
  {
    ID: 1,
    KY_HIEU: 'ho-chuyen-den',
    NAME: 'Danh sách tiếp nhận yêu cầu chuyển vùng hộ gia đình về địa phương'
  },
  {
    ID: 2,
    KY_HIEU: 'thanh-vien-chuyen-di',
    NAME: 'Danh sách yêu cầu chuyển thành viên sang hộ gia đình mới (khác địa phương)'
  },
  {
    ID: 3,
    KY_HIEU: 'thanh-vien-chuyen-den',
    NAME: 'Danh sách tiếp nhận yêu cầu chuyển thành viên về địa phương'
  }
];

export const TAB_QUY_TRINH_CHUYEN_TE = [
  {
    ID: 0,
    KY_HIEU: 'tre-em-chuyen-di',
    NAME: 'Danh sách yêu cầu chuyển hồ sơ trẻ em sang địa phương khác'
  },
  {
    ID: 1,
    KY_HIEU: 'tre-em-chuyen-den',
    NAME: 'Danh sách tiếp nhận yêu cầu chuyển hồ sơ trẻ em về địa phương'
  }
]

export const TRANG_THAI_CHUYEN_VUNG = {
  CHO_DUYET: 0,
  DA_DUYET: 1,
  DA_TU_CHOI: 2,
  GUI_LAI: 3,
  YEU_CAU_TU_CHOI: 4
}

export const MA_DANH_SACH_DOI_TUONG = {
  TRE_EM_MO_COI:        1,
  NGUOI_TU_16_22:       2,
  NGUOI_NHIEM_HIV:      3,
  DON_THAN:             4,
  NGUOI_CAO_TUOI:       5,
  NGUOI_KHUYET_TAT:     6,
  NGUOI_NHAN_CHAM_SOC:  7
}

export const CAP_DON_VI = [
  { id: 0, name: "Cấp trung ương" },
  { id: 1, name: "Cấp tỉnh" },
  { id: 3, name: "Cấp xã" }
]

export const QUAN_TRI_HE_THONG = 9;
export const CAP_TAI_KHOAN = [
  { id: 1, name: "Cấp tỉnh/thành phố" },
  { id: 3, name: "Cấp xã/phường" },
  { id: 9, name: "Cấp thôn/ấp" },
  { id: 4, name: "Cấp đơn vị" },
  { id: 5, name: "Trung tâm BTXH" },
  { id: 6, name: "Cấp trung ương" },
  { id: 7, name: "Trung tâm GDNN" },
  { id: 8, name: "Người dân" },
  
];
export const SUPER_ADMIN = 25;
export const DANH_SACH_DO_TUOI = [
  { id: 0, name: 'Không phải là người cao tuổi' },
  { id: 1, name: 'Là người cao tuổi' }
]
export const GIOI_TINH = [
  { id: 0, name: 'Nữ' },
  { id: 1, name: 'Nam' }
]

export const MAU_BAO_CAO = [
  { id: 0, name: 'Báo cáo cai nghiện 503' },
  { id: 1, name: 'Báo cáo cai nghiện 504_505' }
]
